/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Представление всплывающего окна
   */
  app.CartReorderingPopupView = app.View.extend({
    template: '#re-ordering-list',
    events: {
      'click .to-checkout': 'goToCheckout',
      'click .js-extra-services-popup-opener': 'toggleExtraServicesPopup',
    },
    // По умолчанию отображаем в попапе кнопку создания нового заказа
    isStandardOrderAvailable: true,
    additionalOptions: ['opener', 'bodyView'],
    fetchData: {
      'expand': 'items,order_delivery,reordering_extra_services',
      'sort': '-created_at',
      'per-page': 20,
      'reordering': 1,
    },

    /** @inheritDoc */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.initPopup();
      this.setCartChanged(true);
      this.listenTo(this.cart, 'sync destroy', this.setCartChanged.bind(this, true));
      this.listenTo(this.collection, 'sync', this.render);
    },

    /**
     * Инициализация лебедевского попапа.
     */
    initPopup: function () {
      if (!app.isMobile) {
        this.popup = new als.Popup(this.$el);
        this.popup.addEventListener(
          als.Popup.EventType.BEFORE_OPEN,
          function () {
            app.helpers.PopupPositioningHelper.positionCenterOfWindow(this.$el);
          }.bind(this)
        );
      } else if (typeof app.MobilePopupFillView !== 'undefined' ) {
        this.childViews.popupView = new app.MobilePopupFillView({
          el: this.$el,
          bodyView: this.bodyView,
        });
        this.popup = this.childViews.popupView.popup;
      }
    },

    /** @inheritDoc */
    render: function () {
      var content = '';
      this.$('#group-purchase-city').val(this.settlement.get('name') + ' (' + this.settlement.get('region') + ')');
      this.$('#city-choose-container').data('city-id', this.settlement.get('settlement_id'));
      if (this.collection.length) {
        content = this.template({
          collection: this.collection.toJSON(),
          isStandardOrderAvailable: this.isStandardOrderAvailable
        });
      }
      this.$('.list-container').html(content);
    },

    /**
     * Отправляем на дозаказ, либо возвращаемся к оформлению обычного заказа
     * @param event Событие нажатия на кнопку
     */
    goToCheckout: function (event) {
      var current = $(event.currentTarget);
      var id = current.data('id');

      if (id) {
        this.makeReorder(id);
      } else {
        this.makeOrder();
      }
      current.prop('disabled', true);
      this.popup.close();
    },

    /**
     * Оформляем дозаказ.
     * @param {Number} id ID заказа.
     */
    makeReorder: function (id) {
      var model = this.collection.get(id);
      var services = this.getServicesList();
      var options = {};

      if (services.length) {
        options.saveOptions = {
          newOrderData: {
            extra_services: services,
          },
        };
      }

      if (model) {
        this.trigger('reordering-popup:make-reorder', model, options);
      }
    },

    /**
     *  Оформляем обычный заказ.
     */
    makeOrder: function () {
      this.trigger('reordering-popup:make-standard-order');
    },

    /**
     * Проверяем, есть ли дозаказы.
     */
    checkReorders: function () {
      // Если корзина изменилась, перезапрашиваем список заказов
      if (this.isCartChanged) {
        this.listenToOnce(this.collection, 'sync', this.updatePopup);
        this.fetchReorders();
      } else {
        this.updatePopup();
      }
    },

    /**
     * Запрос списка заказов, доступных для дозаказа.
     */
    fetchReorders: function () {
      this.collection.fetch({
        data: this.fetchData
      });
    },

    /**
     * Установка признака, что корзина была обновлена.
     * @param {Boolean} state была ли изменена корзина
     */
    setCartChanged: function (state) {
      this.isCartChanged = Boolean(state);
    },

    /**
     * Обновить состояние попапа.
     */
    updatePopup: function () {
      var hasOrders = Boolean(this.collection.length);
      if (hasOrders) {
        this.render();
        this.openAlsPopup();
      }
      this.setCartChanged(false);
      this.trigger('reordering-popup:updated', hasOrders);
    },

    /**
     * Открытие попапа. Хак для лебедевского попапа.
     */
    openAlsPopup: function () {
      setTimeout(this.popup.open.bind(this.popup), 0);
    },

    /**
     * Показать/скрыть попап с информацией о дополнительных услугах.
     * @param {Event} e
     */
    toggleExtraServicesPopup: function (e) {
      var serviceId = $(e.target).data('serviceId');
      if (serviceId && typeof serviceId !== 'undefined'){
        this.$('#js-extra-services-popup-'+serviceId).toggleClass('not_display');
        if (app && app.bodyView) {
          app.bodyView.toggleScrollLock();
        }
      }
    },

    /**
     * Возвращает список идентификаторов выбранных услуг из чекбоксов.
     */
    getServicesList: function () {
      var serviceList = [];
      this.$('.js-service-checkbox:checked').each(function(i, el){
        serviceList.push(el.dataset.serviceId);
      });
      return serviceList;
    }
  });
})(jQuery);

}.call(window));